// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"Channel_infoContainer__3H9-m","detailContainer":"Channel_detailContainer__jHKDI","graphContainer":"Channel_graphContainer__WF5h6"};